import { createSlice } from '@reduxjs/toolkit';

const initialState = {
    showCreateOrder: false,

};

const panelSlice = createSlice({
  name: 'menu',
  initialState,
  reducers: {
    handleOpenCreateOrder: (state) => {
        state.showCreateOrder = true;
    },
    handleCloseCreateOrder(state) {
        state.showCreateOrder = false;
    },
  },
});

export const { handleOpenCreateOrder,handleCloseCreateOrder } = panelSlice.actions;
export default panelSlice.reducer;


